import { NgModule }            from '@angular/core';
import { BrowserModule }       from '@angular/platform-browser';
import { FormsModule }         from '@angular/forms';
import { HttpModule }          from '@angular/http';

import { AppRoutingModule } from './app-routing.module';

import { environment } from '../environments/environment';

// imports for loading Firebase/AngularFire
import { AngularFireModule } from 'angularfire2';
// import { AngularFireOfflineModule } from 'angularfire2-offline';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

// components
import { AddFromRecipeComponent }  from './components/add-from-recipe/add-from-recipe';
import { NewListRecipeComponent }  from './components/new-list-recipe/new-list-recipe';
import { ItemComponent }  from './components/item/item';
import { SignInUpComponent }  from './components/sign-in-up/sign-in-up';
import { AppComponent }  from './components/app/app';
import { ModalComponent }  from './components/modal/modal';
import { SnackBarComponent }  from './components/snack-bar/snack-bar';
import { HeaderComponent }  from './components/header/header';
import { MenuComponent }  from './components/menu/menu';
import { FeedbackModalComponent }  from './components/feedback-modal/feedback-modal';
import { LogoutComponent }  from './components/logout/logout';
import { UserAvatarComponent }  from './components/user-avatar/user-avatar';
import { SettingsComponent }  from './components/settings/settings';
import { AdminComponent }  from './components/admin/admin';
import { HomepageComponent }  from './components/homepage/homepage';
import { ManageListsRecipesComponent }  from './components/manage-lists-recipes/manage-lists-recipes';
import { ManageListRecipeComponent }  from './components/manage-list-recipe/manage-list-recipe';
import { ManageSharingModalComponent }  from './components/manage-sharing-modal/manage-sharing-modal';
import { ManageSharedListComponent }  from './components/manage-shared-list/manage-shared-list';
import { ListRecipeComponent }  from './components/list-recipe/list-recipe';
import { scaleRecipeComponent }  from './components/scale-recipe/scale-recipe';
import { NewItemComponent }  from './components/new-item/new-item';
import { SelectUnitComponent }  from './components/select-unit/select-unit';

// Services
import { FirebaseService } from './services/firebase.service';
import { SnackBarService } from './services/snack-bar.service';

@NgModule({
  imports      : [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    // AngularFireOfflineModule,
    AngularFireAuthModule
  ],
  declarations : [
    AppComponent,
    ModalComponent,
    SnackBarComponent,
    HeaderComponent,
    MenuComponent,
    FeedbackModalComponent,
    SignInUpComponent,
    LogoutComponent,
    UserAvatarComponent,
    SettingsComponent,
    AdminComponent,
    HomepageComponent,
    ManageListsRecipesComponent,
    ManageListRecipeComponent,
    ManageSharingModalComponent,
    ManageSharedListComponent,
    NewListRecipeComponent,
    ListRecipeComponent,
    scaleRecipeComponent,
    NewItemComponent,
    AddFromRecipeComponent,
    ItemComponent,
    SelectUnitComponent
  ],
  providers    : [
    FirebaseService,
    SnackBarService
  ],
  bootstrap    : [
    AppComponent
  ]
})

export class AppModule {}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/app.module.ts